import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";

export default function About() {
  const state = useSelector((state) => state);

  const [size, setSize] = useState("contain");
  const [position, setPosition] = useState("top");

  useEffect(() => {
    setInterval(() => {
      setSize("cover");
      setPosition("center");
    }, 500);
  }, []);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            backgroundSize: size,
            backgroundPosition: position,
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/math.jpg") +
              "')",
          }}
        >
          <div
            style={{
              fontSize: "55px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            About Math
          </div>
        </div>
        <div className="aboutabout" style={{ marginTop: "100px" }}>
          <div
            style={{
              fontSize: state.auth.isMobile ? "16px" : "22px",
              fontFamily: "Montserrat",
              textAlign: "justify",
            }}
          >
            Sri Adichunchanagiri Mahasamsthana Math, with its roots firmly
            embedded in the folds of time (1500 Years), Space on Rocky hill, 63
            miles West of Bangalore, the Capital City of Karnataka has been
            working towards the betterment of human life and society. By
            following 'Guru-Shishya' Parampara, His Holiness Paramapoojya
            Jagadguru Padmabhushana Sri Sri Dr. Balagangadharanatha Mahaswamiji,
            71 in the holy lineage, who ascended the reverend seat in 1974. The
            benevolent activities of social service gained an accelerated
            momentum since then. Sri Math has established all over Karnataka,
            Tamilnadu, Andrapradesh, Uttarpradesh, Delhi, America and Srilanka
          </div>
        </div>
        <div className="aboutabout2" style={{ marginTop: "-150px" }} id="aandu">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: state.auth.isMobile ? "100%" : "80%",
            }}
          >
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                lg={6}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  style={{
                    width: "100%",
                    maxHeight: "60vh",
                    objectFit: "cover",
                    margin: "10px",
                    maxWidth: state.auth.isMobile ? "100vw" : "20vw",
                    marginTop: state.auth.isMobile ? "-100px" : "0px",
                  }}
                  src={require("../img/about2.png")}
                />
                <b style={{ texAlign: "left" }}> Founder, President</b>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                xl={6}
                style={{ marginLeft: state.auth.isMobile ? "0px" : "-100px" }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontWeight: "bold",
                  }}
                >
                  His Holiness Bhairavaikya Paramapoojya Padmabhushana Sri Sri
                  Sri Dr. Balagangadharanatha Mahaswamiji
                </div>
                <br />
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "16px" : "22px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                  }}
                >
                  Sri Adichunchanagiri Shikshana Trust was founded in the year
                  1974 under the divine leadership of His Holiness Paramapoojya
                  Jagadguru Padmabhushana Sri Sri Sri Dr. Balagangadharanatha
                  Mahaswamiji. More than 500 Educational Institutions with
                  student strength of above 1.6 lakh inclusive of Adi
                  Chunchanagiri University, medical colleges,Hospital and
                  Research centres, Ayurvedic medical colleges, colleges of
                  Engineering, nursing, pharmacy, degree, agriculture,
                  polytechnic and PU, International Schools, Central schools for
                  blind are being managed by the Trust. All these institutions
                  spand across the India to provide abundant opportunities with
                  world class facilities and infrastructure.
                </div>
              </Grid>
            </Grid>
          </div>
        </div>

        <div className="aboutabout2" style={{ marginTop: "-150px" }} id="pandu">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: state.auth.isMobile ? "100%" : "80%",
            }}
          >
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                lg={6}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  style={{
                    width: "100%",
                    maxHeight: "60vh",
                    objectFit: "cover",
                    margin: "10px",
                    maxWidth: state.auth.isMobile ? "100vw" : "20vw",
                    marginTop: state.auth.isMobile ? "-100px" : "0px",
                  }}
                  src={require("../img/about1.png")}
                />
                <b style={{ texAlign: "left" }}> President</b>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                xl={6}
                style={{ marginLeft: state.auth.isMobile ? "0px" : "-100px" }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontWeight: "bold",
                  }}
                >
                  Parama Poojya Jagadguru Sri Sri Sri Dr. Nirmalanandanatha
                  Mahaswamiji President
                </div>
                <br />
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "16px" : "22px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                  }}
                >
                  Jagadguru Sri Sri Sri Dr. Nirmalanandanatha Mahaswamiji,
                  President of Sri Adichunchanagiri Shikshana Trust the 72nd
                  Pontiff of Sri Adichunchanagiri Maha Samsthana Math. Poojya
                  Guruji is fulfilling vision of the founder President by
                  constantly and continuously guiding all of us and to further
                  improve quality of academic standards in educational
                  institutions.
                  <br /> All educational institutions, Temples, Tabernacles and
                  other philanthropic centres are developing rapidly under the
                  enlightened leadership of Poojya Sri Guruji. In addition to
                  the social activities of the Math, Sri Guruji is encouraging
                  the rural masses to pursue basic education, particularly in
                  the field of Science.
                  <br />
                  <br /> Education comes from living life, following passions,
                  accessing information, observing, reflecting and being
                  inspired by wise and courageous elders in the community. Hence
                  the first step in education is learning to recognize the
                  creator's image in man and consequently learning to have
                  profound respect for every human being. Parama Poojya
                  Jagadguru
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <div
          className="aboutabout2"
          style={{ marginTop: "-150px" }}
          id="chandu"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: state.auth.isMobile ? "100%" : "80%",
            }}
          >
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                lg={6}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  style={{
                    width: "100%",
                    maxHeight: "60vh",
                    objectFit: "cover",
                    margin: "10px",
                    maxWidth: state.auth.isMobile ? "100vw" : "20vw",
                    marginTop: state.auth.isMobile ? "-100px" : "0px",
                  }}
                  src={require("../img/princ2.jpeg")}
                />
                <b style={{ texAlign: "left" }}> Secretary</b>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                xl={6}
                style={{ marginLeft: state.auth.isMobile ? "0px" : "-100px" }}
              >
                <div
                  style={{
                    fontSize: "20px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontWeight: "bold",
                  }}
                >
                  Sri Sri Annadhaneshwaranatha Swamiji Secretary Sri
                  Adichunchanagiri Shakha Math Ramanagara
                </div>
                <br />
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "16px" : "22px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                  }}
                >
                  Sri Sri Annadhaneswaranatha Swamiji is a distinguished
                  spiritual stalwart, revered for his exemplary leadership and
                  unwavering commitment to the service of humanity. As an
                  esteemed Secretary of the venerable Sri Adichunchanagiri
                  Shakha Math, Ramanagaram, Swamiji has been instrumental in
                  perpetuating the sacred traditions and values of this esteemed
                  institution.
                  <br />
                  As the Visionary Founder and President of Sri Shivaldappa
                  Murthy Annadana Math, Shivagiri Kshetra, Swamiji has created a
                  sanctum of spiritual solace, where the needy and the
                  downtrodden find succor and sustenance. His tireless efforts
                  to provide annadana (food) to the marginalized, promote
                  education, and foster community development have had a
                  profound impact on the lives of countless individuals.
                  <br />
                  <br />
                  Swamiji's remarkable leadership, infused with wisdom,
                  compassion, and spiritual insight, has earned him the
                  reverence and admiration of devotees worldwide. His presence
                  is a beacon of hope, guiding humanity towards a path of
                  righteousness, selflessness, and spiritual enlightenment.
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <br></br>
        <br></br>
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
